// components/focusMode/useFocusMode.js
import { useEffect, useState } from "react";

export default function useFocusMode(storageKey = "cms_focus_mode") {
  const [focusMode, setFocusMode] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(storageKey);
    if (saved === "1") setFocusMode(true);
  }, [storageKey]);

  useEffect(() => {
    localStorage.setItem(storageKey, focusMode ? "1" : "0");
  }, [storageKey, focusMode]);

  return {
    focusMode,
    setFocusMode,
    openFocus: () => setFocusMode(true),
    closeFocus: () => setFocusMode(false),
    toggleFocus: () => setFocusMode((v) => !v),
  };
}